export default "__VITE_ASSET__CDA8jC$Z__"